export enum CheckTypeEnum {
  Unchecked = '0',
  Checked = '1',
}

export enum EnableStatus {
  DISABLED = '0', // 禁用
  ENABLED = '1', // 启用
}

export interface ServiceItem {
  name: string; //服务品名称
  skuId: string; //服务品sku
  landedPriceText: string; //到手价
  crossPriceText: string; //划线价
  checkType: CheckTypeEnum; //选中状态
  /** 详情页URL */
  detailUrl: string;
  statusText: string | null;
  uuid: string | null;
  enable: EnableStatus;
  // stockState: string;
}

export interface ServiceFloorData {
  title: string; //服务弹层标题
  serviceItems: ServiceItem[]; //服务品列表
}
